module.exports = __webpack_public_path__ + "img/organization-2.ebf6acfd.jpg";